export class LandingWineTemplateApiModel {
	landingWineTemplateID: number;
	daysBeforeSend: number;
	active: boolean;
    landingWineTypeID: number;
	subject: string;
	emailContent: string;
	deleted: boolean;
	createDate: string;
	lastActionDate: string;
    createUserID: number;
    lastActionUserID: number;
}
